import { render, staticRenderFns } from "./TenantBanner.vue?vue&type=template&id=5a4b3f14&scoped=true"
import script from "./TenantBanner.vue?vue&type=script&lang=js"
export * from "./TenantBanner.vue?vue&type=script&lang=js"
import style0 from "./TenantBanner.vue?vue&type=style&index=0&id=5a4b3f14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4b3f14",
  null
  
)

export default component.exports